/**
 * AI Client - Routes AI requests through AWS Lambda functions
 * Supports OpenAI, Anthropic, and Gemini via Lambda proxy
 */

export async function callLambdaFunction(endpoint, payload) {
  if (!endpoint) {
    throw new Error('Lambda endpoint not configured. Please set up the AWS Lambda URL.');
  }

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller?.abort(), 30000);

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload),
      signal: controller?.signal
    })?.finally(() => clearTimeout(timeoutId));

    if (!response?.ok) {
      const errorText = await response?.text()?.catch(() => 'Unknown error');
      throw new Error(`Lambda function error (${response?.status}): ${errorText}`);
    }

    const data = await response?.json();
    return data;
  } catch (error) {
    if (error?.name === 'AbortError') {
      throw new Error('AI request timed out. Please try again.');
    }
    if (error?.message?.includes('Failed to fetch') || error?.message?.includes('NetworkError')) {
      throw new Error('Unable to connect to AI service. Please check your internet connection.');
    }
    throw error;
  }
}

export default callLambdaFunction;
